



















import { defineComponent, ref, onMounted, onUnmounted, useContext } from "@nuxtjs/composition-api";
import PBHelper from "./utils/helper";
import PBComponent from "./utils/component";
import MvStyle from "./components/MvStyle.vue";
import { html2json } from "html2json_2";
import { useGtm } from "~/composables";
import { trim } from "lodash-es";
const { loadAsyncComponent } = PBComponent();

export default defineComponent({
  name: "PageBuilder",
  components: {
    MvStyle,
    ...loadAsyncComponent(),
  },
  props: {
    pageBuilderStyle: {
      type: String,
      default: "",
    },
    inlineStyle: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
    inlineJs: {
      type: String,
      default: "",
    },
    dynamicBlocks: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const { getComponentName, convertMagentoLink, bindGtmEvent, bindFaqToggleEvent, bindAnchorScrollEvent, bindPortfolioTableToggleEvent } = PBHelper();
    const layouts = ref([]);
    const { eventCustomlinksInteracted, eventDocumentDownload } = useGtm();
    const { app: { i18n } } = useContext();
    let unbindPortfolioTableToggleEvent = () => {};

    const htmlContent = convertMagentoLink(props.content);
    const htmlJson = html2json(htmlContent);
    if (htmlJson["child"] && htmlJson["child"].length > 0) {
      layouts.value = htmlJson["child"];
    }
    onMounted(async () => {
      bindGtmEvent('.bulleted-list-download .htmlContent .card-content ul li a, a.download-file-events, .download-file-events a', (e) => {
        eventDocumentDownload({
          "documentName": trim(e.href.substring(e.href.lastIndexOf('/')+1)),
          "ProductName": trim(e.textContent),
          "ProductCategory":"PDP",
        });
      });

      const useDefaultWhenEmpty = (str, defaultValue = '') => {
        if(str === null || str === '') {
          return defaultValue;
        } else {
          return str;
        }
      };
      bindGtmEvent('.btn-link a, .btn-link span, a.load-more, .title-link a, .bulleted-list-link a, .bulleted-list-link a span,' +
        ' a.btn-link, .board-of-directors a,[data-appearance-type=applications] .card-content li > a,' +
        ' a.click-link-events, .click-link-events a, .click-link-events a b', (e) => {
        eventCustomlinksInteracted({
          "eventlabel": useDefaultWhenEmpty(trim(e.getAttribute('data-text')), trim(e.textContent)),
          "eventCategory": "Cms Page Button Links",
        });
      });
      bindFaqToggleEvent();

      bindAnchorScrollEvent();

      unbindPortfolioTableToggleEvent = bindPortfolioTableToggleEvent((label) => i18n.t(label));
    });

    onUnmounted(() => {
      unbindPortfolioTableToggleEvent();
    });

    return {
      layouts,
      getComponentName,
    };
  },
});
